import request from "@/utils/request";

let messageList = [];
const initMessageList = function(params) {
    console.log('initMessageList params:', params);
    const count = parseInt(params.limit);
    for (const index in [...Array(count)]) {
        const seq = parseInt(index) + 1;
        const item = {seq:seq, 
            messageCd:seq == 1 ? 'sms' : 'email', 
            title:`릴레이 이벤트 ${seq} 차`,
            count:Math.ceil(Math.random()*10), 
            regId:`regId_${seq}`, regDt:'2022-05-01'
        };
        messageList.push(item);
    }
}

const getTestMessageList = async function(params) {
    //console.log('getTestMessageList:', params.limit);

    messageList.splice(0, messageList.length);
    initMessageList(params);
    const result = {
        data: messageList,
        count: messageList.length
    }
    console.log('messageList result:', result);
    return result;
}

const getTestMessageDetail = async function(params) {
    const seq = params.seq;
    return messageList.find((item) => item.seq == seq);
}

// 메시지 API 
export async function getMessageList(params, isTest) {
    console.log("@@ get list : getMessageList");
    return isTest ? getTestMessageList(params) : request.get("/api/marketing/msg/",{params});
}

export async function getMessageDetail(params, isTest) {
    console.log("@@ get item : getMessageDetail");
    return isTest ? getTestMessageDetail(params) : request.get(`/api/marketing/msg/${params.msgSeq}`);
}

export async function saveMessage(params) {
    console.log("@@ post save : saveMessage");
    let result = request.post(`/api/marketing/msg/`,params);
    return result;
}

export async function deleteMessage(params) {
    console.log("@@ delete : deleteMessage");
    let result = request.delete(`/api/marketing/msg/${params.msgSeq}`);
    return result;
}

// 메시지 보낼 유저 검색 -> /api/user/ 사용

// 발송대상 등록
export async function addMessageSendUsers(params) {
    console.log("@@ post : addMessageSendUsers");
    let result = request.post(`/api/marketing/userMsg/`, params);
    return result;
}

